var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("SalesKPIRecord", {
        ref: "salesKPIRecord",
        attrs: {
          "opt-config": _vm.optConfig,
          storecode: _vm.storeCode,
          storeid: _vm.storePk,
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "m-actions" },
        [
          _vm.mode === "edit"
            ? [
                _c(
                  "el-button",
                  { attrs: { size: "small" }, on: { click: _vm.onSaveDraft } },
                  [_vm._v(_vm._s(_vm.$t("common.saveDraft")))]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "small" },
                    on: { click: _vm.onNext },
                  },
                  [_vm._v(_vm._s(_vm.$t("common.nextStep")))]
                ),
              ]
            : [
                _c(
                  "el-button",
                  {
                    key: _vm.mode,
                    attrs: {
                      type: "primary",
                      size: "small",
                      disabled: _vm.mode === "error",
                    },
                    on: { click: _vm.onNext },
                  },
                  [_vm._v(_vm._s(_vm.$t("common.nextStep")))]
                ),
              ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }